/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemAmountResponse
 */
export interface RedeemAmountResponse {
    /**
     * Static amount indicator (always 1)
     * @type {number}
     * @memberof RedeemAmountResponse
     */
    amount: number;
}

/**
 * Check if a given object implements the RedeemAmountResponse interface.
 */
export function instanceOfRedeemAmountResponse(value: object): value is RedeemAmountResponse {
    let isInstance = true;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;

    return isInstance;
}

export function RedeemAmountResponseFromJSON(json: any): RedeemAmountResponse {
    return RedeemAmountResponseFromJSONTyped(json, false);
}

export function RedeemAmountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemAmountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
    };
}

export function RedeemAmountResponseToJSON(value?: RedeemAmountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
    };
}

